<template>
  <o-dialog
    ref="dialog"
    :title="$t('components.customer.actions.creditBalance.title')"
    :info="$t('components.customer.actions.creditBalance.info', { name: customer.displayName })"
    :options="[
      { text: $t('general.cancel'), type: 'cancel' },
      { text: $t('general.apply'), type: 'confirm', callback: confirm },
    ]"
    :portal="portal"
    :valid="validate"
  >
    <div class="mt-4 text-left ">
      <o-form ref="form">
        <o-field-group v-slot="{ status }" :label="$t('general.balance')" :name="$t('general.balance')" rules="required" class="block pb-3">
          <number-field v-model="creditBalance" :status="status" />
        </o-field-group>
      </o-form>
    </div>
  </o-dialog>
</template>

<script setup lang="ts">
import { NumberField } from '@/components/fields'

import type { Customer } from '~/_api/models/customer'

interface Props {
  customer: Customer
  portal?: string
  loading?: boolean
}

interface Emits {
  (e: 'success'): void
}

const props = withDefaults(defineProps<Props>(), {
  portal: undefined,
  loading: false,
})

const emit = defineEmits<Emits>()
const { $api, $i18n, $notification, $bus } = useNuxtApp()

const dialog = ref<any>()
const form = ref<any>()
const creditBalance = ref(0)

const open = () => {
  dialog.value.open()
  creditBalance.value = props.customer.balances.credit
}

const confirm = async () => {
  try {
    const response = await $api.customer.updateCreditBalance(
      props.customer.idCustomer.toString(),
      creditBalance.value,
    )

    if (response.success) {
      emit('success')

      $bus.emit.updated('Customer', response.data)

      $notification.toast({
        title: $i18n.t('components.customer.actions.creditBalance.success'),
        variant: 'success',
      })

      return response
    }
  } catch (e) {
    console.log(e)
  }
}

const validate = () => {
  return form.value.validate()
}

defineExpose({ open })
</script>
